export const PRODUCT_SHOW_RESET = 'PRODUCT_SHOW_RESET'
export const PRODUCT_SHOW_SET_ERROR = 'PRODUCT_SHOW_SET_ERROR'
export const PRODUCT_SHOW_SET_RETRIEVED = 'PRODUCT_SHOW_SET_RETRIEVED'
export const PRODUCT_SHOW_TOGGLE_LOADING = 'PRODUCT_SHOW_TOGGLE_LOADING'
export const PRODUCT_SHOW_SET_COMPANY_PRODUCTS = 'PRODUCT_SHOW_SET_COMPANY_PRODUCTS'
export const PRODUCT_SHOW_SET_PRODUCT_SELL_PRICES = 'PRODUCT_SHOW_SET_PRODUCT_SELL_PRICES'



// WEBPACK FOOTER //
// ./src/store/modules/product/show/mutation_types.js